import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cbmist">
        <Loader2 className="animate-spin text-primary" size={32} />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/portal/login" state={{ from: location.pathname }} replace />;
  }
  return children;
}
